
// Equalize heights of components in the same "row" (option)
export function equalizeComponentHeights() {
    $(window).on('load', function () {
        $('.flexibleLayouts.flexibleLayouts-js-equalize').each(function (i, layout) {
            $(layout).find('.flexibleLayouts__column').each(function (i, column) {
                $(column).find('.flexibleComponent').each(function (i, component) {
                    equalizeHeights(".flexibleComponent-index-" + (i + 1), $(layout));
                });
            });
        });
    });
}


function equalizeHeights(group, parent) {
    parent = parent || "body";
    jQuery(parent).each(function() {
        var tallest = 0;
        jQuery(this).find(group).css('min-height', 0);

        jQuery(this).find(group).each(function() {
            var $this = jQuery(this);
            var thisHeight = $this.height();

            if($this.css('box-sizing') === 'content-box') {
                if(thisHeight > tallest) {
                    tallest = thisHeight;
                }
            } else {
                var thisPadding = Number($this.css('padding-top').replace('px', ''))
                    + Number($this.css('padding-bottom').replace('px', ''));

                if((thisHeight + thisPadding) > tallest) {
                    tallest = thisHeight + thisPadding;
                }
            }
        });
        jQuery(this).find(group).css('min-height',tallest);
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/equalizeHeights.js